export enum BM {
  /** Styrelseordförande */
  Of = 'of',
  /** VD */
  Vd = 'vd',
  /** Suppleant */
  Su = 'su',
  /** Styrelseledamot */
  Le = 'le',
  /** Vice VD */
  Vvd = 'vvd',
  /** Extern VD */
  Evd = 'evd',
  /** Extern Vice VD */
  Evvd = 'evvd',
  /** Auditor */
  Rev = 'rev',
  /** Head auditor */
  Revh = 'revh',
}

export const allBoardMembers: BM[] = [BM.Evd, BM.Evvd, BM.Le, BM.Of, BM.Su, BM.Vd, BM.Vvd];

export const regularBoardMembers: BM[] = [BM.Le, BM.Of];
